import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export var normalizeVideo = function normalizeVideo(url) {
  url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
  var type = '';
  if (RegExp.$3.indexOf('youtu') > -1) {
    if (url.includes('youtube.com/live')) type = 'youtube-live';else type = 'youtube';
  } else if (RegExp.$3.indexOf('vimeo') > -1) {
    type = 'vimeo';
  }
  return {
    vendor: type,
    id: type === 'youtube-live' ? url.split('live/')[1].split('?')[0] : RegExp.$6
  };
};